module.exports = __webpack_public_path__ + "static/media/400393_01.11709b7c.png";